"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectMimicToken = exports.selectTokens = exports.withoutMimicToken = exports.withoutTokens = exports.applyAuthState = void 0;

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var applyAuthState = function applyAuthState(authState) {
  return function (state) {
    if (Object.keys(authState).length > 0) {
      return _objectSpread({}, state, {}, authState);
    }

    return state;
  };
};

exports.applyAuthState = applyAuthState;
var withoutTokens = (0, _utils.withoutKey)('tokens');
exports.withoutTokens = withoutTokens;
var withoutMimicToken = (0, _utils.withoutKey)('mimicToken');
exports.withoutMimicToken = withoutMimicToken;

var selectTokens = function selectTokens(state) {
  return state.tokens;
};

exports.selectTokens = selectTokens;

var selectMimicToken = function selectMimicToken(state) {
  return state.mimicToken;
};

exports.selectMimicToken = selectMimicToken;